import { Descriptions } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utils/helpers/date';
import { formatPLN } from '../../../utils/helpers/formatNumber';
import { COMPENSATION_BASIS_SHORT } from '../../../utils/helpers/lawBasis';
import { toUnit } from '../../../utils/helpers/money';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { useTypedSelector } from '../../../store';
import { PartialResult } from '../../../store/sumUp';
import { GRID_SM } from '../../../styles';
import { DescFullWidth } from '../../../styles/ui';
import { WpsTitle } from '../WpsFees/WpsTitle';

const { Item: DescItem } = Descriptions;

const DetailsPartialComp = ({ partialResult }: { partialResult: PartialResult }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const compensationOn = useTypedSelector((state) =>
    state.sumUp.lawsuitOpts.compensationOn);
    // eslint-disable-next-line
  if (compensationOn) {
    return (
      <>
        <WpsTitle title={`${t('detailsPartialComp.title')} art. 10 ${COMPENSATION_BASIS_SHORT}`} />
        <DescFullWidth
          layout={width > GRID_SM ? 'horizontal' : 'vertical'}
          bordered
          key={partialResult.key}
        >
          <DescItem span={3} label={t('detailsPartialComp.euro')}>
            {`${toUnit(partialResult.compensationResult?.valueEuro ?? 0)} euro`}
          </DescItem>
          <DescItem label={t('detailsPartialComp.day')} span={3}>
            {formatDate(partialResult.compensationResult?.lastWorkingDay ?? '')}
          </DescItem>
          <DescItem label={t('detailsPartialComp.avg')} span={3}>
            <>{partialResult?.compensationResult?.exchangeRate}</>
          </DescItem>
          <DescItem span={3} label={t('detailsPartialComp.pln')}>
            <ResultText>{`${formatPLN(partialResult.compensationResult?.valuePLN)}`}</ResultText>
          </DescItem>
        </DescFullWidth>
      </>
    );
  }
  return null;
};

export default DetailsPartialComp;

export const ResultText = styled.span`
	font-size: 15px;
	font-weight: 600;
`;
